import { JDSAvatarV2StatusProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<JDSAvatarV2StatusProps>
  ): React.FC<JDSAvatarV2StatusProps> =>
  (props: JDSAvatarV2StatusProps) => {
    return <Component {...props} />;
  };
